<template lang="pug">
div.sidebyside.w-flex.wrap(
  :style="{width,backgroundColor,flexDirection: (imageLeft) ? 'row-reverse' : ''}"
)
  div.column.sidebyside-content.w-flex.justify-center.align-center
    slot
  div.column.sidebyside-image.w-flex.justify-center.align-center
    router-link(v-if="imageRoute" :to="imageRoute")
      w-image.sidebyside-image(
        tag="img"
        :src="image"
        :width="imgWidth"
        :height="imgHeight"
        contain
      )
    w-image.sidebyside-image(
      v-else
      tag="img"
      :src="image"
      :width="imgWidth"
      :height="imgHeight"
      contain
    )
</template>

<script>

export default {
  name: 'Sidebyside',
  data() {
    return {
    }
  },
  props: {
    backgroundColor: {
      type: String,
      required: false,
      default: "lightblue",
      note: 'CSS background-color'
    },
    image: {
      type: String,
      required: true,
      note: 'Image src'
    },
    width: {
      type: String,
      required: false,
      default: '100%',
      note: 'CSS width'
    },
    height: {
      type: String,
      required: false,
      default: 'auto',
      note: 'CSS height'
    },
    imgWidth: {
      type: String,
      required: false,
      default: '100%',
      note: 'CSS image width'
    },
    imgHeight: {
      type: String,
      required: false,
      default: '100%',
      note: 'CSS image height'
    },
    ratio: {
      type: Number,
      required: false,
      default: 0.5,
      note: 'The width ratio'
    },
    imageRoute: {
      type: Object,
      required: false,
      default: undefined,
      note: 'Image route'
    },
    imageLeft: {
      type: Boolean,
      required: false,
      default: false,
      note: 'Show the image on the left side'
    },
  },
  computed: {
  },
  methods: {
  },
  components: {
  },
  watch: {
  }
}
</script>

<style lang="scss">
.sidebyside {
  .sidebyside-image {
    .w-image {
      background-position: center;
    }
  }
  .column{
    flex-basis: 300px;
    flex-grow: 1;
    padding: 20px;
  }
}
</style>